// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"acd009ae","180":"91df3865","225":"f9ebe8d9","331":"1fb126d0","409":"f93b55dd","416":"e140935f","455":"e273b353","472":"ab12d276","591":"e6736e6a","604":"d7a0ce9e","607":"a15e5884","703":"3a30d357","782":"8ebdc870","847":"eaa7aa2c"}[chunkId] + ".chunk.js";
};